<template>
    <section class="mt-16">
      <v-row>
        <v-col cols="12" offset="0" md="10" offset-md="1">    
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-account-hard-hat</v-icon> <span>Edição de avaliação de fornecedor</span>
        </h1>
  
        <div>
          <v-progress-linear v-if="loading"
            indeterminate
            class="global-loader"
          ></v-progress-linear>
  
          <template v-if="loading">
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row class="mt-6" align="center" justify="space-around">
              <v-skeleton-loader
                  type="button"
                ></v-skeleton-loader>
            </v-row>
          </template>
          <v-card v-else elevation="0">
            <v-container fluid>
                <SupplierEvaluation method="update" :evaluation="evaluation"></SupplierEvaluation>
            </v-container>
          </v-card>
        </div>
        </v-col>
        </v-row>
    </section>
  </template>
  <script>
  import SupplierEvaluationAPI from "@/api/SupplierEvaluation.js";
  import SupplierEvaluation from '@/components/supplier_evaluation/Evaluation.vue'
  
  export default {
    components: {
        SupplierEvaluation,
    },
    beforeCreate(){
      document.title = "ODC - Edição de avaliação de fornecedor";
    },
    data: () => ({
      tab: null,
      supplier: {},
      loading:true
    }),
    mounted(){
  
        if(!this.$store.getters.hasPermission(["super", "supplier_evaluations.update"])) {
            this.$router.push('/forbidden');
        }

        SupplierEvaluationAPI.find(this.$route.params.id).then(({data}) => { 
            this.evaluation = data; 
            this.loading = false;
        });
    },
    methods:{
      
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/dashboard',
            exact: true,
          },
          {
            text: 'Avaliações',
            disabled: false,
            to: '/evaluations',
            exact: true,
          },
          {
            text: 'Edição de avaliação de fornecedor',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  